module.exports = __webpack_public_path__ + "static/media/4.baa56b65.jpg";